import scrollMonitor from 'scrollmonitor'
import { requestTimeout } from '../util'

const $panels = $('.technology-panel')

const wrapListItems = () => {
  $('.technology-panel__content ul li').each((index, el) => {
    $(el).wrapInner('<div>')
  })
}

const setupScroll = () => {
  $panels.each((index, el) => {
    const panelWatcher = scrollMonitor.create(el, -(Math.floor($(el).height() / 2)))

    panelWatcher.enterViewport(() => {
      $(el).find('.technology-panel__icon').addClass('technology-panel__icon--active')

      requestTimeout(() => {
        $(el).find('.technology-panel__content').addClass('technology-panel__content--active')
      }, 300)

      requestTimeout(() => {
        $(el).find('.technology-panel__image').addClass('technology-panel__image--active')
      }, 600)
    })
  })
}

const setupImageZoom = () => {
  $('.image-popup').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
    fixedContentPos: true,
    mainClass: 'mfp-no-margins',
    image: {
      verticalFit: true
    }
  });
}

export default {
  can: () => $('body').hasClass('page-technology'),
  run: () => {
    wrapListItems()
    setupScroll()
    setupImageZoom()
  }
}
